(function () {
  if (!window.Shopify || !Shopify.Product || !Shopify.Product.prototype) {
    return;
  }

  Shopify.Product.prototype.update = function (json) {
    for (var property in json) {
      if (Object.prototype.hasOwnProperty.call(json, property)) {
        this[property] = json[property];
      }
    }
  };
})();